import { GQLCartFragment, GQLOperationalSettingsFragment } from '@theprintbar/graphql';
import { cn } from '@theprintbar/shared';
import { CartItem } from './CartItem';

interface CartItemProps {
	settings: GQLOperationalSettingsFragment;
	cart: GQLCartFragment;
	className?: string;
	hideLinks?: boolean;
	hasPopover?: boolean;
	quoteSession?: any;
}

export function CartItems({ settings, cart, hideLinks, className, hasPopover, quoteSession }: CartItemProps) {
	return (
		<div className={cn('divide-y-[1px] divide-blue max-h-96 overflow-y-auto', className)}>
			{cart.items?.map(item => (
				<CartItem
					settings={settings}
					hasPopover={hasPopover}
					sameday={!!cart.sameday}
					key={item.id}
					hideLinks={hideLinks}
					item={item}
					quoteSession={quoteSession}
				/>
			))}
		</div>
	);
}
